import React from 'react';

const TelegramIcon: React.FC = () => {
  return (
    <div className="telegram-icon-container">
      <a 
        href="https://t.me/SEPTONG_RR88_GG88"
        target="_blank" 
        rel="noopener noreferrer"
        className="telegram-link"
      >
        <img 
          src="/assets/tele-icon.png" 
          alt="Telegram" 
          className="telegram-icon"
        />
      </a>
      
      <style dangerouslySetInnerHTML={{
        __html: `
          .telegram-icon-container {
            position: fixed;
            bottom: 20px;
            left: 20px;
            z-index: 1000;
          }
          
          .telegram-link {
            display: block;
            transition: transform 0.3s ease;
          }
          
          .telegram-link:hover {
            transform: scale(1.1);
          }
          
          .telegram-icon {
            width: 100%;
            height: 130px;
            border-radius: 50%;
            cursor: pointer;
          }
          
          @media (max-width: 1024px) {
            .telegram-icon-container {
              bottom: 18px;
              left: 18px;
            }
            
            .telegram-icon {
              width: 100px;
              height: 100px;
            }
          }
          
          @media (max-width: 768px) {
            .telegram-icon-container {
              bottom: 80px;
              right: 0px;
              left: auto;
            }
            
            .telegram-icon {
              width: 80px;
              height: 80px;
            }
          }
          
          @media (max-width: 480px) {
            .telegram-icon-container {
              bottom: 80px;
              right: 0px;
              left: auto;
            }
            
            .telegram-icon {
              width: 100px;
              height: 70px;
            }
          }
        `
      }} />
    </div>
  );
};

export default TelegramIcon;
